import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Auto-update for content drops. The standard PWA-update lifecycle:
      //
      // 1. Deploy new web bundle → live web has new sw.js content
      // 2. Tester reopens TWA → browser fetches sw.js (no-cache, always
      //    revalidates) → sees content differs from registered SW
      // 3. Browser installs new SW (calls skipWaiting in install handler,
      //    so it doesn't sit waiting for old clients to close)
      // 4. New SW activates → calls clients.claim() to take control of
      //    existing clients (this page) without requiring a tab close
      // 5. controllerchange event fires here → we reload the page → new
      //    HTML loads → references new bundle hashes → fresh content
      //
      // The reload is what was missing before. Without it, even after the
      // SW chain finished, the page kept its already-rendered React tree
      // (built from old HTML referencing old bundles). Tester saw old
      // version. Manual app-data-clear was needed to break the loop.
      //
      // Now: the moment the new SW takes control, page auto-reloads and
      // tester sees the new content — zero action required from them.
      //
      // Guard against the FIRST install (page loaded fresh without an
      // existing SW controller). controllerchange fires once on first
      // install too, but reloading then is unnecessary (the page is
      // already on fresh content) and would cause an infinite reload
      // loop on first visit. Only listen if a controller was already
      // present at registration time.
      if (navigator.serviceWorker.controller) {
        let reloaded = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
      }
      // Suppress "unused" — we don't need reg further but the .then()
      // signature is what we want for chained error handling.
      void reg;
    }).catch((err) => {
      console.warn('sw register failed', err);
    });
  });
}
